import { addBestValueShippingBanner } from '../custom/add-best-value-shipping-banner';
import { formatShippingMethodDisplay } from '../custom/format-shipping-method-display';
import type { EbizioEventConfig } from '../types';
import { EBIZIO_EVENT_TYPE } from '../types';
import { logger, setActiveStepOnBody } from '../utils';

export const shippingStepLoadingConfig: EbizioEventConfig = {
  event: EBIZIO_EVENT_TYPE.SHIPPING_STEP_LOADING,
  handler: ({ detail }) => {
    logger('Shipping Step Loading');
    setActiveStepOnBody(detail.activeStepType);
    console.log(detail);

    formatShippingMethodDisplay();

    if (detail.consignments !== null && detail.consignments.length > 0) {
      addBestValueShippingBanner(detail.consignments);
    }
  },
};
